export default __webpack_public_path__ + "static/media/chat2.e6562ea8.jpeg";